import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'

import Box from '../../component/Box/Box'
import Page from '../../component/Page/Page'
import Notify from '../../services/Notify'
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem'
import HttpRequest from '../../services/HttpRequest'
import {dayMonthYearAtTime} from '../../utils/dates'
import {NodeOfflineDetailType} from './CustomAlert/NodeOfflineAlert/NodeOfflineDetailType'
import {ALERT_ID, ALERT_TITLE} from "./Select/AlertSelect";
import {WrongWorkFlowDetailType} from './CustomAlert/WrongWorkFlow/WrongWorkFlowDetailType'
import {TitlePage} from '../../component/Page/Title'
import {ExportTableButton} from '../../component/Button/ExportTableButton'
import ExportData from '../../utils/ExportData'
import LoadingV2 from '../../component/Loading/LoadingV2'
import {AlertService} from '../../services/AlertService'
import {PermanenceDetailType} from './CustomAlert/PermanenceAlert/PermanenceDetailType'
import {StockLevelCriticDetailType} from './CustomAlert/StockLevelAlert/StockLevelDetailType'

function AlertDetailPage({match}) {

  const [isLoading, setIsLoading] = useState(false)
  const [contentDownloadIsLoading, setContentDownloadIsLoading] = useState(false)
  const [alertDetails, setAlertDetails] = useState(null)
  const [currentDetailType, setCurrentDetailType] = useState(null)

  const alertService = new AlertService()
  const getAlertDetail = async () => {
    try {
      setIsLoading(true)
      const alertDetail = await alertService.getAlertById(match.params.id)
      setAlertDetails(alertDetail)
    } catch (error) {
      Notify.error('Erro ao recuperar os dados do seu alerta', error)
    } finally {
      setIsLoading(false)
    }
  }

  const exportContent = async (contentType) => {
    try {
      Notify.showLoading(`Carregando ${contentType} ...`)
      setContentDownloadIsLoading(true)

      const {columns, getColumns} = currentDetailType.metadata

      const endpointWithParams = `${currentDetailType.endpoint}${currentDetailType.endpoint.includes('?') && '&' || '?'}size=5000`
      const {content} = await new HttpRequest().get(endpointWithParams)

      if (contentType === ExportData.EXPORT_CONTENT_TYPES.PDF) {
        ExportData.exportToPDF(content, getColumns ? getColumns() : columns, 'Detalhes do alerta')
      } else {
        ExportData.exportToCsv(content, getColumns ? getColumns() : columns, 'Detalhes do alerta')
      }

      Notify.success(`${contentType} baixado com sucesso!`)
    } catch (error) {
      Notify.error(`Erro ao baixar ${contentType}`, error)
    } finally {
      setContentDownloadIsLoading(false)
    }
  }

  const renderDetailtType = (type) => {
    switch (type) {
      case ALERT_ID.PERMANENCE_TIME_ALERT:
        return <PermanenceDetailType data={alertDetails} setCurrentDetailType={setCurrentDetailType}/>
      case ALERT_ID.STOCK_LEVEL_CRITICAL_ALERT:
        return <StockLevelCriticDetailType data={alertDetails} setCurrentDetailType={setCurrentDetailType}/>
      case ALERT_ID.NODE_OFFLINE_ALERT:
        return <NodeOfflineDetailType data={alertDetails} setCurrentDetailType={setCurrentDetailType}/>
      case ALERT_ID.WORKFLOW_ALERT:
        return <WrongWorkFlowDetailType data={alertDetails} setCurrentDetailType={setCurrentDetailType}/>
      default:
        return 'Sem detalhes para o tipo ' + type;
    }
  }

  useEffect(() => {
    getAlertDetail()
  }, [])

  const headerCustom = (
    <Row>
      <Col md={8} sm={8} lg={8}>
        <TitlePage title="Detalhes do alerta"/>
      </Col>
      <Col md={4} className="d-flex justify-content-end">
        <LoadingV2 isLoading={!currentDetailType || contentDownloadIsLoading}>
          <ExportTableButton title="Exportar para PDF" icon="file-pdf-o" onClick={() => exportContent(ExportData.EXPORT_CONTENT_TYPES.PDF)}/>
          <ExportTableButton title="Exportar para CSV" icon="file-text-o" onClick={() => exportContent(ExportData.EXPORT_CONTENT_TYPES.CSV)}/>
        </LoadingV2>
      </Col>
    </Row>
  )
  return (
    <Page isLoading={isLoading} headerCustom={headerCustom}
          breadcrumbs={[<BreadcrumbItem title="Lista de alertas" to="/list/alerts"/>]}>
      <Box>
        <Row>
          <Col md={6} className="d-flex mb-3">
            <h4>
              <span style={{fontWeight: 'bold'}}>Nome: &nbsp;</span>
              {alertDetails && alertDetails.alertConfiguration.friendlyName}
            </h4>
          </Col>
          <Col md={6}>
            <h4>
              <span style={{fontWeight: 'bold'}}>Tipo: &nbsp;</span>
              {alertDetails && ALERT_TITLE[alertDetails.alertConfiguration.type]}
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="d-flex mb-3">
            <h4 style={{fontWeight: 'bold'}} className="mr-3">Data e hora:</h4>
            <h4 className="text-bold">{alertDetails && dayMonthYearAtTime(alertDetails.createdAt)}</h4>
          </Col>
          <Col md={6} className="d-flex">
            <h4 style={{fontWeight: 'bold'}} className="mr-3">Descrição:</h4>
            <h4 className="text-bold">{alertDetails && alertDetails.alertConfiguration.description}</h4>
          </Col>
        </Row>
      </Box>
      <Box title={alertDetails && ALERT_TITLE[alertDetails.alertConfiguration.type] + " - Detalhes do alerta"}>
        {alertDetails && renderDetailtType(alertDetails.alertConfiguration.type)}
      </Box>
    </Page>
  )
}

export {AlertDetailPage}



// WEBPACK FOOTER //
// ./src/pages/Alerts/AlertDetailPage.js